import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import styled from 'styled-components';
import { DraftToHtml } from '../../draft-to-html/draft-to-html';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { TextBlockModel } from '../../../model/block';
import { isDraftEmpty } from '../../../util/draft/is-draft-empty.util';
import { findLinkedDataById } from '../../../util/page/find-linked-data-by-id.util';

interface ITextBlockWrapperProps {
  backgroundColor: string;
  hasPadding: boolean;
}

const TextBlockWrapper = styled.div`
  padding: ${(props: ITextBlockWrapperProps) => props.hasPadding ? 20 : 0}px 13px;
  word-wrap: break-word;
  background: ${(props: ITextBlockWrapperProps) => props.backgroundColor};
  ${getCenterOfPageStyle()}
`;

@inject('state')
@observer
export class TextBlockView extends BaseBlockView<TextBlockModel, IInjectedProps> {
  render() {
    const mentions = this.props.content.getUsedMentions(this.props.state.activeDesign.data);
    const hasContent = mentions.length === 0 ? !isDraftEmpty(this.props.content.text) : mentions.some((mention) => {
      const linkedData = findLinkedDataById(mention, this.props.state.activeDesign.data);
      return (linkedData && linkedData.data !== null && linkedData.data !== undefined) || this.props.dataItem;
    });
    if (!hasContent && !this.props.inEditor) {
      return null;
    }
    return (
      <TextBlockWrapper backgroundColor={this.props.state.colors.getColor(this.props.content.textBackgroundColor)} hasPadding={this.props.content.hasPadding}>
        <DraftToHtml
          draft={this.props.content.text}
          dataItem={this.props.dataItem}
          inEditor={this.props.inEditor}
        />
      </TextBlockWrapper>
    );
  }
}
